const { getFeatureConfig } = require('../helpers/utils');
const { nodeHelper } = require('../helpers/node-helpers');
const { formatUrl, getLocalObjectAlt } = require('../helpers/app-helpers.js');

const featureConfig = getFeatureConfig('youtubeIframe');

// For backward compatibility, this should be removed after code refactoring.
const globalConfig = require('../../config');

/**
 * Perform initialization tasks for this feature
 *
 * @param {object} config Configuration passed by initialization code
 */
exports.initialize = async (config) => {
  featureConfig.enabled = config.enable_youtube_iframe || globalConfig.enable_youtube_iframe;
};

/**
 * Is used to check if the feature is enabled or not.
 *
 * @returns boolean
 */
exports.isEnabled = () => {
  return !!featureConfig.enabled;
};

/**
 * Traverse over nodes to localized media/asset urls.
 *
 * @param {object} node Single dom node
 * @param {function|undefined} callback Callback to handle post tracversing action
 * @returns object
 */
exports.traverseNodes = async (node, callback) => {
  if (nodeHelper(node).isAnIframe()) {
    for await (const handler of handlers) {
      node = await handler(node);
    }
  }

  return node;
};

/**
 * Various handlers to perform different actions on given node.
 */
const handlers = [
  async (node) => {
    if (node.src && globalConfig.enable_youtube_iframe) {
      let localUrl = '';
      let objectEnglishUrl = '';

      // If the url is absolute
      //   if (node.src.includes('http')) {
      //     globalConfig.requested_domain = !globalConfig.requested_domain.endsWith('/')
      //       ? globalConfig.requested_domain + '/'
      //       : globalConfig.requested_domain;
      //     objectEnglishUrl = node.src.replaceAll(globalConfig.requested_domain, globalConfig.domain);
      //   } else {
      //     objectEnglishUrl = `${globalConfig.domain}/${node.src}`;
      //   }
      objectEnglishUrl = node.src;
      let currentYoutubeId = getYoutubeId(objectEnglishUrl);
      if (!currentYoutubeId) {
        return node;
      }
      let localYoutubeUrl = getLocalObjectUrl(currentYoutubeId);
      if (!localYoutubeUrl) {
        return node;
      }
      let localYoutubeId = getYoutubeId(localYoutubeUrl);
      if (!localYoutubeId) {
        return node;
      }
      //   window.player1 = new YT.Player('player', {
      //     videoId: currentYoutubeId
      //   });

      const nodeId = node.id;
      let container = document.getElementById(nodeId);
      let containerWidth = 0;
      let containerHeight = 0;
      if (container) {
        containerWidth = container.getAttribute('width');
        containerHeight = container.getAttribute('height');
        if (document.querySelector(globalConfig.youtube_iframe_html_tag)) {
          container.remove();
        } else {
          console.log('Please check the youtube_iframe_html_tag configuration');
        }
      }

      if (!container) {
        console.log('Player container not found. Creating a new one...');
        container = document.createElement('div');
        container.id = nodeId;
        const videoContainer = document.querySelector(globalConfig.youtube_iframe_html_tag);
        if (videoContainer) {
          videoContainer.appendChild(container);
        }
      }
      const settings = {
        videoId: localYoutubeId
      };
      //   if (containerWidth && containerHeight) {
      //     settings.width = containerWidth;
      //     settings.height = containerHeight;
      //   }
      window.player2 = new YT.Player(nodeId, settings);
    }
    return node;
  }
];

function getLocalObjectUrl(englishUrl) {
  const formattedUrl = formatUrl(englishUrl); // Ensure consistent formatting
  const matchingKey = Object.keys(globalConfig.subdomain_object_urls_hash_map).find((key) =>
    key.includes(formattedUrl)
  );
  return matchingKey && globalConfig.subdomain_object_urls_hash_map[matchingKey].local_url
    ? globalConfig.subdomain_object_urls_hash_map[matchingKey].local_url
    : '';
}

function getYoutubeId(url) {
  // Regular expressions for YouTube URLs
  var regexList = [
    /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?|shorts)\/|.*[?&]v=)|youtu\.be\/)([\w-]{11})/, // standard, embed, shorts, youtu.be
    /youtube\.com\/watch\?.*v=([\w-]{11})/, // watch?v=
    /youtube\.com\/embed\/([\w-]{11})/, // embed
    /youtube\.com\/v\/([\w-]{11})/, // /v/
    /youtube\.com\/shorts\/([\w-]{11})/, // shorts
    /youtu\.be\/([\w-]{11})/, // youtu.be link
    /embed\/([\w-]{11})/ // generic embed
  ];

  for (var i = 0; i < regexList.length; i++) {
    var match = url.match(regexList[i]);
    if (match && match[1]) {
      return match[1];
    }
  }
  return null;
}
